import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,0 960,0 Z M960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 Z M1113,721 L1113,805.047059 L893.111732,805.047059 L893.111732,910.552941 L1083.50279,910.552941 L1083.50279,988.341176 L893.111732,988.341176 L893.111732,1177 L793,1177 L793,721 L1113,721 Z",
  fillRule: "evenodd",
  stroke: "#979797",
  strokeWidth: "1"
});

var IconFilesFairUseSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFilesFairUseSolid, _Component);

  var _super = _createSuper(IconFilesFairUseSolid);

  function IconFilesFairUseSolid() {
    _classCallCheck(this, IconFilesFairUseSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilesFairUseSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilesFairUse",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilesFairUseSolid.displayName = "IconFilesFairUseSolid";
  return IconFilesFairUseSolid;
}(Component);

IconFilesFairUseSolid.glyphName = 'files-fair-use';
IconFilesFairUseSolid.variant = 'Solid';
IconFilesFairUseSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilesFairUseSolid;
export { IconFilesFairUseSolid };